<template>
  <div class="__BillingReport">
    <BillingReportHeader
      v-model="selectedMonth"
      :data="allData"
      :loading="loading"
      :report-hash="reportHash"
      :owner="owner"
      :date-range="{ start: start, end: end }"
      @update-date-range="onUpdateDateRange"
      :min-date="minDate"
      :max-date="maxDate"
    />

    <BillingReportBody :data="allData" :loading="loading" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';
import { hash } from '@/vuex/modules/billingReports';
import BillingReportHeader from '@/components/BillingReport/BillingReportHeader';
import BillingReportBody from '@/components/BillingReport/BillingReportBody';
import SectionHeader from '../uikit/SectionHeader';
import ReportTable from './ReportTable';
import Amount from '../uikit/Number';
import LoadingMask from '../uikit/LoadingMask';
import heroChartMixin from '@/components/CustomCharts/heroChartMixin';

export default {
  name: 'BillingReport',
  components: {
    BillingReportHeader,
    BillingReportBody,
    SectionHeader,
    ReportTable,
    Amount,
    LoadingMask,
  },
  mixins: [heroChartMixin],
  props: {
    owner: { type: String, required: true },
    ownerId: { type: String, required: false },
    type: { type: String, required: true },
  },
  data() {
    return {
      // Default setting
      dimension: 'monthly',
      selectedMonth: this.reportReadyMonth,
    };
  },
  watch: {
    usageReport: {
      handler(oldReport, newReport) {
        if (this.ownerId) {
          if (!oldReport || newReport !== oldReport) {
            this.fetchBillingReports();
          }
        }
      },
    },
  },
  computed: {
    ...mapState({
      reportReadyMonth: state => state.userState.dataReady.report,
      vendor: state => state.vendor,
    }),

    ...mapState('billingReports', {
      reports: state => state.reports,
      reportRequests: state => state.requests,
    }),

    ...mapState('user', {
      resourceType: state => state.data.resource_type,
    }),

    ...mapState('reports_v2', {
      start: state => state.start,
      end: state => state.end,
    }),

    loading() {
      const request = this.reportRequests[this.reportHash];
      return request && request.inProgress;
    },

    allData() {
      const allData = this.reports[this.reportHash];
      if (allData) {
        return allData;
      }
      return [];
    },

    selectedDate() {
      if (this.selectedMonth) {
        if (this.dimension === 'monthly') {
          return moment(this.selectedMonth)
            .startOf('month')
            .format('YYYY-MM-DD');
        }
      }
    },

    usageReport() {
      let to = '';
      let from = this.selectedDate;

      if (this.vendor === 'aws') {
        from = this.start;
        to = this.end;
      } else {
        if (this.dimension === 'monthly') {
          to = moment(this.selectedMonth)
            .endOf('month')
            .format('YYYY-MM-DD');
        }
      }

      return {
        owner: this.owner,
        ownerId: this.ownerId,
        dimension: this.dimension,
        from: from,
        to: to,
        vendor: this.vendor,
        type: this.type,
        resourceType: this.resourceType,
      };
    },

    reportHash() {
      return hash(this.usageReport);
    },
  },
  methods: {
    fetchBillingReports() {
      if (this.usageReport.owner === 'tagresource') {
        if (this.usageReport.ownerId === 'nontag') {
          this.$store.dispatch('billingReports/fetchNonTagReports', this.usageReport);
        } else {
          this.$store.dispatch('billingReports/fetchTagReports', this.usageReport);
        }
      } else {
        this.$store.dispatch('billingReports/fetchReports', this.usageReport);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.__BillingReport {
  &_Header {
    position: relative;

    &_TotalAmount {
      position: absolute;
      bottom: 0;
      right: 5px;
    }
  }
}

.report-body {
  position: relative;
  height: 100%;
  &.loading {
    height: 400px;
    overflow: hidden;
  }
}
</style>
